import React from 'react';

const CaptchaSection = ({ 
  formData, 
  setFormData, 
  captcha, 
  captchaError, 
  captchaDisabled, 
  handleRefreshCaptcha, 
  isSubmitting 
}) => {
  return (
    <div className="mb-8 animate-fade-in">
      <h3 className="text-black font-semibold mb-6 text-xl font-poppins">
        Spam Prevention
      </h3>
      <p className="text-gray-600 mb-6 text-sm font-poppins">
        Please enter the verification code below:
      </p>
      
      {captchaError && (
        <div className="mb-6 max-w-md mx-auto bg-red-50 border border-red-200 rounded-lg p-4">
          <p className="text-red-700 font-poppins text-sm">{captchaError}</p>
        </div>
      )}
      
      <div className="max-w-md mx-auto p-4 sm:p-6 bg-white rounded-xl border border-black/10 shadow-lg">
        <div className="text-3xl font-bold text-center mb-6 font-poppins tracking-wider bg-gray-100 py-4 px-6 rounded-lg border border-gray-300">
          {captcha.code}
        </div>
        
        <button
          type="button"
          onClick={handleRefreshCaptcha}
          disabled={captchaDisabled || isSubmitting}
          className="mb-6 w-full py-2 px-4 border border-gray-300 rounded-lg font-semibold font-poppins text-sm hover:bg-gray-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Refresh Code
        </button>
        
        <div className="relative">
          <label htmlFor="captchaCode" className="block text-sm font-medium text-gray-700 mb-2 font-poppins">
            Enter Verification Code
          </label>
          <input
            type="text"
            id="captchaCode"
            name="captchaCode"
            required
            value={formData.captchaCode}
            onChange={(e) => setFormData({ ...formData, captchaCode: e.target.value })}
            disabled={isSubmitting}
            className={`w-full px-4 py-3 border rounded-lg font-poppins transition-all duration-300 focus:ring-2 focus:ring-black focus:border-black ${
              captchaError ? 'border-red-500' : 'border-gray-300'
            } disabled:opacity-50 disabled:cursor-not-allowed`}
            placeholder="Enter verification code"
          />
          {captchaError && (
            <p className="mt-1 text-sm text-red-600 font-poppins">{captchaError}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default CaptchaSection;